import hit from "../../../assets/audio/hit.mp3"

export const Explosion = ({ pos, done }) => {
  const s3 = {
    top: `calc(${pos.y} * 100% / var(--grid-size))`,
    left: `calc(${pos.x} * 100% / var(--grid-size))`,
  }

  const gif_duration = 1700 / 2
  setTimeout(done, gif_duration)

  new Audio(hit).play()

  return (
    <>
      <div className="explosion" style={s3}></div>
    </>
  )
}
